import {
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST,
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS,
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE,
} from '../actions/types/domains-with-counts-action-types';

import { combineReducers } from 'redux';

function allParentDomainIds( state = [], action ){
    let newState = [];
    switch( action.type ){
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST:
            if( action.params.pageNum === 1 ){
                newState = [];
            }
            else{
                newState = state;
            }
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS:
            newState = [...state, ...action.allIds];
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS:
            newState = { ...state, ...action.byId };
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST:
            newState = true;
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS:
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function params( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST:
            newState = action.params;
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}

function pagination( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS:
            newState = action.pagination;
            break;
        case FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    allParentDomainIds,
    byId,
    isLoading,
    pagination,
    params,
} );
